export default __webpack_public_path__ + "static/media/x33-square-icon.379d26d1.svg";